import { createIdSchema } from "@/schemas/createId";
import { credentialGradeIdSchema } from "@/types/credentialGrade";
import { credentialStatusIdSchema } from "@/types/credentialStatus";
import { isoDateSchema } from "@/types/isoDate";
import z from "zod";

export const CredentialSchema = z.object({
  id: z.string(),
  state: z.string(),
  subjectId: z.string(),
  licenseNumber: z.string().nullable(),
  gradeId: credentialGradeIdSchema.nullable(),
  statusId: credentialStatusIdSchema.nullable(),
  issueDate: isoDateSchema.nullable(),
  expirationDate: isoDateSchema.nullable(),
});

export type Credential = z.infer<typeof CredentialSchema>;

export const CredentialCreateSchema = z.strictObject({
  ...CredentialSchema.shape,
  id: createIdSchema,
  gradeId: credentialGradeIdSchema.nullish(),
  statusId: credentialStatusIdSchema.nullish(),
  issueDate: isoDateSchema.nullish(),
  expirationDate: isoDateSchema.nullish(),
});
export type CredentialCreate = z.infer<typeof CredentialCreateSchema>;
